/**
 * Copyright FunASR (https://github.com/alibaba-damo-academy/FunASR). All Rights
 * Reserved. MIT License  (https://opensource.org/licenses/MIT)
 */
/* 2021-2023 by zhaoming,mali aihealthx.com */

export function WebSocketConnectMethod( config, Uri ) { //定义socket连接方法类

	
	var speechSokt;
	var connKeeperID;
	
	var msgHandle = config.msgHandle;
	var stateHandle = config.stateHandle;
	
	// 确保返回一个对象实例
	var instance = {};
			  
	instance.wsStart = function (options) {
		return new Promise((resolve, reject) => {
			if(Uri.match(/wss:\S*|ws:\S*/)) {
				console.log("Uri"+Uri);
			} else {
				reject('请检查wss地址正确性');
			}
			if ( 'WebSocket' in window ) {
				speechSokt = new WebSocket( Uri ); // 定义socket连接对象
				speechSokt.onopen = function(e){
					onOpen(e, options);
					resolve(1);
				}; // 定义响应函数
				speechSokt.onclose = function(e){
					console.log("onclose ws!");
					//speechSokt.close();
					onClose(e);
				};
				speechSokt.onmessage = function(e){ options.onMessage ? options.onMessage(e) : onMessage(e);};
				speechSokt.onerror = function(e){
					onError(e, options);
				};
			}
			else {
				reject('当前浏览器不支持 WebSocket');
			}
		})
	};
	
	// 定义停止与发送函数
	instance.wsStop = function () {
		if(speechSokt != undefined) {
			console.log("stop ws!");
			speechSokt.close();
		}
	};
	
	instance.wsSend = function ( oneData ) {

		if(speechSokt == undefined) return;
		if ( speechSokt.readyState === 1 ) { // 0:CONNECTING, 1:OPEN, 2:CLOSING, 3:CLOSED

			speechSokt.send( oneData );

			
		}
	};
	
	// SOCEKT连接中的消息与状态响应
	function onOpen( e , options) {
		// 发送json
		var chunk_size = new Array( 5, 10, 5 );
		var request = {
			"chunk_size": chunk_size,
			"wav_name":  "h5",
			"is_speaking":  true,
			"chunk_interval":10,
			"itn":getUseITN(),
			"mode":getAsrMode(),
			
		};
		if(config.isfilemode)
		{
			request.wav_format=options.file_ext;
			if(options.file_ext=="wav")
			{
				request.wav_format="PCM";
				request.audio_fs=file_sample_rate;
			}
		}
		
		var hotwords=getHotwords();
 
		if(hotwords!=null  )
		{
			request.hotwords=hotwords;
		}
		console.log(JSON.stringify(request));
		speechSokt.send(JSON.stringify(request));
		console.log("连接成功");
		stateHandle(0);
		options.onOpen?.(e);
 
	}
	
	function onClose( e ) {
		stateHandle(1);
	}
	
	function onMessage( e ) {
 
		msgHandle( e );
	}
	
	function onError( e, options ) {

		console.error("连接"+e);
		stateHandle(2);
		options.onError?.(e);
	}
    
	// 返回实例对象
	return instance;

}

export function WebSocketStopMethod(wsconnecter, isfilemode) {
	var chunk_size = new Array( 5, 10, 5 );
	var request = {
		"chunk_size": chunk_size,
		"wav_name":  "h5",
		"is_speaking":  false,
		"chunk_interval":10,
		"mode":getAsrMode(),
	};
	wsconnecter.wsSend( JSON.stringify(request) );

	if (!isfilemode) {
		setTimeout(function(){
			wsconnecter.wsStop();
		}, 3000 );
	}
}

// 选择asr模型模式
function getAsrMode() {
	return 'online';
}

// 获取热词
function getHotwords() {
	return JSON.stringify({});
}

// 获取是否使用ITN，逆文本标准化
function getUseITN() {
	return false;
}